import NotificationListPage from "@/components/notifications/NotificationListPage"

const PackageNotification = () => (
    <NotificationListPage title="Thông báo" scope="mine" />
)

export default PackageNotification
